import { WebCoreIoCKeys, IoCContainer, IWebCoreIoCContainer, IUtils, DeepCopyHelper, DeepCopyContext } from 'web-core-src';

export class Utils implements IUtils {
    public getApiUrl(urlPart: string): string {
        let coreIoCContainer: IWebCoreIoCContainer = IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
        return new URL(urlPart, coreIoCContainer.websiteConstants.applicationWebsite.FULL_MAIN_DOMAIN_URL).toString();
    }

    public getOADate(): Date {
        let oaDate: Date = new Date(1899, 11, 30);
        return oaDate;
    }

    public getMillisecondsOfaDay(): number {
        let millisecondsOfaDay: number = 24 * 60 * 60 * 1000;
        return millisecondsOfaDay;
    }

    public getPropertyCount(obj: any): number {
        /// <summary>Get the property count of the object</summary>
        let propertyCount: number = 0;
        Object.keys(obj).forEach((propertyName: string): void => {
            if (obj.hasOwnProperty(propertyName)) {
                propertyCount++;
            }
        });

        return propertyCount;
    }

    public deepCopy(target: any, source: any, trimString?: boolean): void {
        let deepCopyHelper = new DeepCopyHelper(trimString);
        let context: DeepCopyContext = {
            target: target,
            source: source,
        };

        DeepCopyHelper.parent = target;
        deepCopyHelper.deepCopy(context);
    }

    public isUndefined(value: any): boolean {
        return value === undefined;
    }

    public isNullOrEmpty(value: any): boolean {
        return value === null || value === undefined || value === '' || value.length === 0; // check jQuery object and arrays
    }

    public isFunctionExists(value: any): boolean {
        return typeof value === 'function';
    }

    public naturalCompare(a: any, b: any): boolean {
        // NOTE:
        // stringArray.sort();               output: 1, 10, 2
        // stringArray.sort(naturalCompare); output: 1, 2, 10
        const ax: Array<any> = [];
        const bx: Array<any> = [];

        a.replace(/(\d+)|(\D+)/g, (_: any, $1: any, $2: any): void => {
            ax.push([$1 || Infinity, $2 || '']);
        });
        b.replace(/(\d+)|(\D+)/g, (_: any, $1: any, $2: any): void => {
            bx.push([$1 || Infinity, $2 || '']);
        });

        let an: any;
        let bn: any;
        let nn: any;
        while (ax.length && bx.length) {
            an = ax.shift();
            bn = bx.shift();
            nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
            if (nn) {
                return nn;
            }
        }

        return ax.length - bx.length === 0;
    }

    public isJsonString(str: string): boolean {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

    public scrollToElement(scrollToElementId: string): void {
        let duration: number = 350;
        $([document.documentElement, document.body]).animate(
            {
                scrollTop: $('#' + scrollToElementId).offset().top,
            },
            duration
        );
    }
}
